import { render, staticRenderFns } from "./page4.vue?vue&type=template&id=f7f92e78&scoped=true"
import script from "./page4.vue?vue&type=script&lang=js"
export * from "./page4.vue?vue&type=script&lang=js"
import style0 from "./page4.vue?vue&type=style&index=0&id=f7f92e78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f92e78",
  null
  
)

export default component.exports